import { useState } from "react";

// call with <Dropdown parent={<div>Parent</div>}><div>Child</div></Dropdown>

export default function Dropdown({parent, child}) {
    const [showDropdown, setShowDropdown] = useState(false);
    return (
        <div onClick={()=>setShowDropdown(!showDropdown)}>
            <div>{parent}</div>
            {showDropdown && <div>{child}</div>}
        </div>
    )
}